/**
 * Lädt einen Blob im Browser herunter, unabhängig vom verwendeten Browser (Chrome, Firefox, Safari).
 * Fix für ein häufiges Problem in Chrome, bei dem asynchrone Downloads nach einem fetch blockiert werden.
 *
 * @param {Blob} blob Der Datei-Blob vom Server
 * @param {string} filename Der gewünschte Dateiname für den Download
 */
export const triggerDownload = (blob, filename) => {
    // Falls msSaveOrOpenBlob (altes IE/Edge) verfügbar ist
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
        return;
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    // WICHTIG: Kein 'display: none', da Chrome das manchmal blockiert. 
    // Wir hängen es unsichtbar an, aber lassen es im DOM-Layout.
    a.style.position = 'absolute';
    a.style.left = '-9999px';
    a.style.visibility = 'hidden';

    a.href = url;
    a.download = filename;

    // Optional: target blank hilft manchmal als Fallback, falls der automatische Download fehlschlägt
    // a.target = '_blank'; 

    document.body.appendChild(a);

    // Chrome/React workaround: Einen Tick warten, bevor der Klick simuliert wird.
    // Das stellt sicher, dass das DOM das <a> Element wirklich erfasst hat.
    setTimeout(() => {
        try {
            a.click();
        } catch (e) {
            console.error('Fehler beim Auslösen des Downloads:', e);
        }

        // Cleanup verzögert, da Chrome bei großen Blobs Zeit braucht, bis der Download-Manager übernimmt
        setTimeout(() => {
            if (document.body.contains(a)) {
                document.body.removeChild(a);
            }
            window.URL.revokeObjectURL(url);
        }, 10000); // 10s Timeout für Chrome
    }, 50);
};
